<ng-container [ngSwitch]="status$ | async">
  <button *ngSwitchCase="'polling'" class="btn-waiting spinner-dark" type="button" disabled="disabled">
    <div class="pollingText">
      <ng-content></ng-content>
    </div>
    <yat-icon id="37dfad1f-a59f-4d63-bbde-a138ae4c46fc" name="loader-light" class="spinner"></yat-icon>
  </button>
  <button *ngSwitchCase="'reconnecting'" class="btn-reconnect spinner-dark" type="button" disabled="disabled">
    {{ reconnectingText ?? ('platform.polling.pollingStatus.reconnectingText' | transloco) }}
    <yat-icon id="e25c85d2-1f8e-427f-9b9a-598a351b818d" name="cloud-off"></yat-icon>
  </button>
  <button *ngSwitchCase="'done'" class="btn-confirm spinner-dark" type="button" disabled="disabled">
    <yat-icon id="d08f58e4-8f40-4b42-a477-e62ee8ae81f2" name="verified-duo"></yat-icon>
    {{ 'platform.polling.pollingStatus.doneText' | transloco }}
    <yat-icon id="158f82f1-12c3-4647-8cc5-8c8bb6d14530" name="verified-duo"></yat-icon>
  </button>
</ng-container>
